import {getProductCategoryList,postProductList,postProductInfo} from '@/api'


const actions = {
	async getProductCategory({commit}){
		let res = await getProductCategoryList()
        if(!res.code){
		commit('SAVE_PRODUCT_CATEGORY',res.data)
        }else{
            alert(res.message)
        }
	},
    async getProductList({commit},{id,page}){
		let res = await postProductList({
            category_id: id,
            page: page,
            page_size: 12,
        })
        if(!res.code){
		commit('SAVE_PRODUCT_LIST',res.data)
        }else{
            alert(res.message)
        }
	},
	async getProductDetail({commit}){
		let res = await postProductInfo()
        if(!res.code){
		commit('SAVE_PRODUCT_DETAIL',res.data)
        }else{
            alert(res.message)
        }
	},

}

const mutations = {
	SAVE_PRODUCT_CATEGORY(state,data){
		state.productCategoryList = data
	},
    SAVE_PRODUCT_LIST(state,data){
		state.productInfo = data
	},
}

const state = {
    productCategoryList:[],
    productInfo:{},

}

const getters = {
	
}

export default {
	actions,
	mutations,
	state,
	getters
}